/**
 * Shift Repository
 * Fetches shifts for dropdowns (e.g. User Rota)
 */

import { apiClient } from '../client'

export interface Shift {
    id: number
    name: string
    from?: string
    to?: string
    status?: number
}

class ShiftRepository {
    async getAll(): Promise<Shift[]> {
        return apiClient.get<Shift[]>('/shifts')
    }

    async getById(id: number): Promise<Shift> {
        return apiClient.get<Shift>(`/shifts/${id}`)
    }
}

export const shiftRepository = new ShiftRepository()
